module.exports = __webpack_public_path__ + "img/solutions-ch3-banner.74e41b9d.png";